<template>
    <li class="vue-navigation-list-item">
        <cp-navigation-link
            :item="item"
            :has-children="hasChildren"
            :active-id="activeId"
            :parent-id="parentId"
            :open="item.open"
            @navigation-link-clicked="handleClicked"
        ></cp-navigation-link>

        <cp-navigation-list
            v-if="hasChildren"
            :items="item.children"
            :active-id="activeId"
            :open="item.open"
            :classNames="getNavigationListClassName"
            @navigation-link-clicked="handleClicked"
            :parent-id="item.id"
            :depth="item.depth + 1"
        ></cp-navigation-list>
    </li>
</template>

<script>
import NavigationLink from "./NavigationLink";

export default {
    name: "NavigationListItem",

    components: {
        'cp-navigation-link': NavigationLink
    },

    props: {
        item: {
            type: Object,
            required: true,
        },

        parentId: {
            type: String,
        },

        activeId: {
            type: null|String,
            default: null,
        }
    },

    computed: {
        hasChildren() {
            return !_.isEmpty(this.item.children)
        },

        hasChildOpen() {
            return !lodash.isNil(this.item.children.find((element) => element.open))
        },

        getNavigationListClassName() {
            if (!this.hasChildOpen) {
                return ''
            }

            return 'child-open'
        }
    },

    methods: {
        handleClicked(payload) {
            this.$emit('navigation-link-clicked', {...payload})
        }
    }
}
</script>